import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Auth/Login/Login';
import ForgetPassword from './pages/Auth/ForgetPassword/ForgetPassword';
import { useAuth } from './context/AuthContext';
import AdminLayout from './components/Admin/AdminLayout/AdminLayout';
import ProtectedRoute from './helper/ProtectedRoute';
import Dashboard from './pages/Admin/Dashboard/Dashboard';
import ResetPassword from './pages/Auth/ResetPassword/ResetPassword';
import PageNotFound from './pages/PageNotFound/PageNotFound';
import Request from './pages/Admin/Request/TeacherRequest/Request';
import Teacher from './pages/Admin/UserManagement/Teacher/Teacher';
import Students from './pages/Admin/UserManagement/Student/Students';
import Settings from './pages/Admin/Settings/Settings';
import RequestDetails from './pages/Admin/Request/TeacherRequest/RequestDetails/RequestDetails';
import TeacherDetails from './pages/Admin/UserManagement/Teacher/TeacherDetails/TeacherDetails';
import SingleSessionDetails from './pages/Admin/UserManagement/Teacher/SingleSessionDetails/SingleSessionDetails';
import Transactions from './pages/Admin/Payment/Transactions/Transactions';
import Disputes from './pages/Admin/Payment/Disputes/Disputes';
import StudentDetails from './pages/Admin/UserManagement/Student/StudentDetails/StudentDetails';
import DisputeDetails from './pages/Admin/Payment/Disputes/DisputeDetails/DisputeDetails';
import ReportDetails from './pages/Admin/Payment/Report/ReportDetails/ReportDetails';
import SingleStudentSessionDetails from './pages/Admin/UserManagement/Student/SingleStudentSessionDetails/SingleStudentSessionDetails';
import TransactionDetails from './pages/Admin/Payment/Transactions/TransactionDetails/TransactionDetails';
import PlatformCharges from './pages/Admin/FeeSettings/PlatformCharges/PlatformCharges';
import PenaltiesCharges from './pages/Admin/FeeSettings/PenaltiesCharges/PenaltiesCharges';
import PrivacyPolicy from './pages/Auth/PrivacyPolicy/PrivacyPolicy';
import VerifyOTP from './pages/Auth/LoginWithOTP/VerifyOTP';
import SubjectRequest from './pages/Admin/Request/SubjectRequest/SubjectRequest';
import SubjectRequestDetails from './pages/Admin/Request/SubjectRequest/SubjectRequestDetail/SubjectRequestDetail';
import Banner from './pages/Admin/Banner/Banner';
import RequestedTag from './pages/Admin/Request/RequestedTag/RequestedTag';
import Organisation from './pages/Admin/Organisation/Organisation';
import CreateOrganisation from './pages/Admin/Organisation/CreateOrganisation/CreateOrganisation';
import OrganisationDetails from './pages/Admin/Organisation/OrganisationDetail/OrganisationDetail';
// import Payout from './pages/Admin/FeeSettings/Payout/Payout';
// import PayoutDetails from './pages/Admin/FeeSettings/Payout/PayoutDetail/PayoutDetail';
import TransactionRecords from './pages/Admin/Organisation/TransactionRecords/TransactionRecords';
import EditOrganisation from './pages/Admin/Organisation/EditOrganisation/EditOrganisation';
// import AddInstructorModal from './components/Admin/Organisation/AddInstructorModal/AddInstructorModal';
import AddInstructor from './pages/Admin/Organisation/AddInstructor/AddInstructor';
import Coupen from './pages/Admin/Coupen/Coupen';
import Rbac from './pages/Admin/RBAC/Rbac';
import SupportHelp from './pages/Admin/Payment/SupportHelp/SupportHelp';
import SupportDetail from './pages/Admin/Payment/SupportHelp/SupportDetail/SupportDetail';
import Payout from './pages/Admin/Payment/Payout/Payout';
import EFT from './pages/Admin/Payment/EFT/EFT';
import EFTDetails from './pages/Admin/Payment/EFT/EFTDetails/EFTDetails';
import PayoutDetails from './pages/Admin/Payment/Payout/PayoutDetails/PayoutDetails';
import Refund from './pages/Admin/Payment/Refund/Refund';
import RefundDetails from './pages/Admin/Payment/Refund/RefundDetails/RefundDetails';
function App() {
  const [auth, , loading] = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<ForgetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-otp" element={<VerifyOTP />} />
          <Route
            path="/"
            element={
              auth?.user_type === 'admin' ? (
                <Navigate to="/admin/dashboard" replace />
              ) : (
                <Navigate to="/page-not-found" replace />
              )
            }
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />

          {auth?.user_type === 'admin' && (
            <Route element={<AdminLayout />}>
              <Route
                path="/admin/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/request"
                element={
                  <ProtectedRoute>
                    <Request />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/request-details/:id"
                element={
                  <ProtectedRoute>
                    <RequestDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/subject-request"
                element={
                  <ProtectedRoute>
                    <SubjectRequest />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/subject-request-details/:id"
                element={
                  <ProtectedRoute>
                    <SubjectRequestDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/requested-tag"
                element={
                  <ProtectedRoute>
                    <RequestedTag />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/organisation"
                element={
                  <ProtectedRoute>
                    <Organisation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/transaction-records"
                element={
                  <ProtectedRoute>
                    <TransactionRecords />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/organisation/:id"
                element={
                  <ProtectedRoute>
                    <OrganisationDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/organisation/create"
                element={
                  <ProtectedRoute>
                    <CreateOrganisation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/organisation/edit/:id"
                element={
                  <ProtectedRoute>
                    <EditOrganisation />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/organisation/add-instructor/:id"
                element={
                  <ProtectedRoute>
                    <AddInstructor />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/users/instructor"
                element={
                  <ProtectedRoute>
                    <Teacher />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/users/instructor-details/:id"
                element={
                  <ProtectedRoute>
                    <TeacherDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/users/instructor/:teacherId/session-details/:id"
                element={
                  <ProtectedRoute>
                    <SingleSessionDetails />
                  </ProtectedRoute>
                }
              />
              {/* Legacy student routes → redirect to learner */}
              <Route
                path="/admin/users/student"
                element={<Navigate to="/admin/users/learner" replace />}
              />
              <Route
                path="/admin/users/student-details/:id"
                element={<Navigate to="/admin/users/learner-details/:id" replace />}
              />
              <Route
                path="/admin/users/student/:teacherId/session-details/:id"
                element={
                  <Navigate to="/admin/users/learner/:teacherId/session-details/:id" replace />
                }
              />

              {/* Learner routes */}
              <Route
                path="/admin/users/learner"
                element={
                  <ProtectedRoute>
                    <Students />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/users/learner-details/:id"
                element={
                  <ProtectedRoute>
                    <StudentDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/users/learner/:teacherId/session-details/:id"
                element={
                  <ProtectedRoute>
                    <SingleStudentSessionDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/fee-settings/platform-charges"
                element={
                  <ProtectedRoute>
                    <PlatformCharges />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/fee-settings/penalties-charges"
                element={
                  <ProtectedRoute>
                    <PenaltiesCharges />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin/payments/payout"
                element={
                  <ProtectedRoute>
                    <Payout />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/payments/payout-details/:id"
                element={
                  <ProtectedRoute>
                    <PayoutDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/payments/transactions"
                element={
                  <ProtectedRoute>
                    <Transactions />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/payments/eft"
                element={
                  <ProtectedRoute>
                    <EFT />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/payments/eft-details/:id"
                element={
                  <ProtectedRoute>
                    <EFTDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/payments/disputes"
                element={
                  <ProtectedRoute>
                    <Disputes />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/payments/refund"
                element={
                  <ProtectedRoute>
                    <Refund />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/payments/refund-details/:id"
                element={
                  <ProtectedRoute>
                    <RefundDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/support"
                element={
                  <ProtectedRoute>
                    <SupportHelp />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/support-detail/:id"
                element={
                  <ProtectedRoute>
                    <SupportDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/payments/disputes-details/:id"
                element={
                  <ProtectedRoute>
                    <DisputeDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/payments/reports-details/:id"
                element={
                  <ProtectedRoute>
                    <ReportDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/settings"
                element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/banner"
                element={
                  <ProtectedRoute>
                    <Banner />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/coupons"
                element={
                  <ProtectedRoute>
                    <Coupen />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/payments/transactions-details/:id"
                element={
                  <ProtectedRoute>
                    <TransactionDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/rbac"
                element={
                  <ProtectedRoute>
                    <Rbac />
                  </ProtectedRoute>
                }
              />
            </Route>
          )}
          <Route path="*" element={auth?.access_token ? <PageNotFound /> : <Navigate to="/" />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
